import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Paragraph,
  List,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Cocktails">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Cocktails, vin &amp; cider</Heading1>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Drinks på fustage sætter gang i festen og er desuden et godt alternativ til øl. Hos Skafte finder du både vin, cider og mange forskellige drinks og cocktails på fad, så du let kan skænke en velsmagende drink for dine gæster, uden at skulle købe de mange ingredienser. Drinks på fustage gør det desuden let at have et varieret udvalg og sparer dig tid. Husk også at leje et fustage anlæg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelCocktailVinCider" filterFadkobling filterLiterSize display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Drinks på fustage til festen</Heading2>
          <Paragraph>
            Skal du holde en fest eller et større arrangement? Hvorfor så ikke byde dine gæster på en skøn drink, cocktail eller vin? Drinks er et godt alternativ til øl og de findes endda også på fad. Vores udvalg af drinks på fustage findes i mange spændende smagsvarianter og giver mulighed for at tilbyde gæsterne en masse valgmuligheder, der passer til forskellig smag og favoritter.
          </Paragraph>
          <Paragraph>
            Cocktails på fad er en let og effektiv måde at servere velsmagende drinks på, uden at du behøver at gå på kompromis med hverken kvalitet, smag eller den helt unikke oplevelse, der følger med at nyde cocktails og drinks.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Stort udvalg af cider og cocktails på fad</Heading2>
          <Paragraph>
            Hos Skafte finder du et stort og lækkert udvalg af drinks og cocktails på fustage, hvor alle kan være med og finde deres favorit. Du finder bl.a. de yderst populære Nohrlund cocktails på fustage, der er gået rent hjem i danskernes hjerter og smagsløg, på grund af den høje kvalitet og altid forventelige velsmag.
          </Paragraph>
          <Paragraph>
            Uanset hvad du eller dine gæster er mest til, så finder du med garanti noget at slukke tørsten i, hvor alle føler sig tilgodeset og glæder sig til at nyde en iskold drink.
          </Paragraph>
          <Paragraph>
            Vores udvalg af drinks på fustager gælder ikke kun de klassiske drinks og cocktails, men du finder også vin og cider i vores sortiment. Du og dine gæster kan bl.a. smage jer gennem følgende:
          </Paragraph>
          <List>
            <li>Mousserende vin</li>
            <li>Æblecider</li>
            <li>Champagne brus</li>
            <li>Rom baserede drinks</li>
            <li>Gin baserede drinks</li>
            <li>Vodka baserede drinks</li>
          </List>
          <Paragraph>
            Der er lidt for enhver smag, uanset om du og dine gæster er mest til en sød drink eller en mere frisk og syrlig variant. Der er mange lækre eksotiske og frugtige varianter at vælge mellem, fx hvor der indgår mango eller passionsfrugt, men der er også de lidt mere cremede og “after dinner” varianter, som fx en fortolkning af en Espresso Martini. Er der brug for en skøn og frisk klassiker, kan du vælge den evigt skønne Mojito eller en Dark ‘n’ Stormy.
          </Paragraph>
          <Paragraph>
            Selvom at der findes mange skønne drinks på fustage, der allerede er klar til at blive tappet ned i glasset og nydes iskolde, så kan det sommetider stadig være rart at kunne mixe sine egne drinks, da det giver rigtig mange muligheder for variationer og personliggørelse.
            Du kan bl.a. finde mousserende vin på fustage, der er perfekt som ingrediens til både Aperol Spritz eller andre spritzer cocktails.
          </Paragraph>
          <Paragraph>
            Hvis der serveres øl til festen eller arrangementet og du ikke ønsker, at der skal serveres drinks eller vin, kan du med fordel vælge cider på fustage. Hos Skafte finder du skøn cider på fad, der fungerer som det perfekte alternativ til øl og hvor de fleste kan være med.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Spar tid og besvær - bestil drinks på fad til det næste arrangement</Heading2>
          <Paragraph>
            Det behøver ikke at være omstændigt at servere lækre drinks til festen. De fleste kender til besværet med at skulle købe ind til forskellige drinks og cocktails, hvor der som regel skal bruges lidt flere ting end forventet. Når indkøbet er på plads og festen er igang, kommer det næste store projekt: at forberede hver eneste drink og cocktail, mens tørstige gæster venter. Det tager tid at lave drinks og den tid ville være sjovere at bruge til festen i selskab med dine gæster, medmindre at der er hyret en bartender.
          </Paragraph>
          <Paragraph>
            Når du vælger drinks og cocktails på fustage, kan du se frem til at kunne nyde en aften i selskab med gæsterne, men uden at gå på kompromis med hverken drinks eller smag. Samtlige drinks på fad der forhandles hos os, er specielt udviklede, så de ikke “mister pusten” eller smagen, selvom de er på fustage. De er nøjagtig lige så friske, som hvis du lavede dem selv, men de største fordele er nok at du sparer tid og at kvalitet er helt i top - i hvert eneste glas.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Lej et fustage anlæg hos Skafte og server lækre drinks på fustage</Heading2>
          <Paragraph>
            Det er heldigvis dejligt let at kunne nyde skønne drinks på fad og det kræver blot en pumpe eller et fustage anlæg.
            Hos Skafte kan du naturligvis også leje et anlæg i samme ombæring, som du bestiller dine drinks på fustage. Du lægger blot en samlet bestilling.
            Der findes flere størrelser af fustage anlæg. Du kan eksempelvis vælge en simpel hane eller en hel bar, så du har mulighed for at tilpasse til festen eller arrangementets størrelse.
          </Paragraph>
          <Paragraph>
            Vores haner og anlæg kan bruges uanset om du vælger cocktail, drinks, cider eller vin på fad - eller hvis du vælger en af hver.
            Skal du holde en stor fest med mange gæster, kan du med fordel også vælge at leje en bardisk eller en stilladsbar, hvor du let kan placere hanerne. Er der derimod tale om et stort arrangement, fx festival, koncert, firmafest eller lignende, kan du også leje en udskænkningsvogn hvor der er 4 udskænknings haner, så der kan serveres til mange mennesker samtidig.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
